import _ from 'lodash';

import { LocaleFlag } from './LocaleFlag';
export function LocalesList({ locales }) {
  return <>{_.map(locales, s => <LocaleFlag round locale={s} key={s}/>)}</>;
}
